// extracted by mini-css-extract-plugin
export default {"brandPromo":"aH-z","carousel":"bH-z"};